/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Digest_HintInputs */

const en_fw_notify_digest_hint = /** @type {(inputs: Fw_Notify_Digest_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One message a day: what got done and what is waiting for you.`)
};

const id_fw_notify_digest_hint = /** @type {(inputs: Fw_Notify_Digest_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu pesan sehari: apa yang selesai dan apa yang menunggu Anda.`)
};

/**
* | output |
* | --- |
* | "One message a day: what got done and what is waiting for you." |
*
* @param {Fw_Notify_Digest_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_digest_hint = /** @type {((inputs?: Fw_Notify_Digest_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Digest_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_digest_hint(inputs)
	return en_fw_notify_digest_hint(inputs)
});